import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import router from '@/router/index.js'
import ElementUI from 'element-ui'
import '@/common/scss/element-variables.scss'
import store from './store'
import { Base64 } from 'js-base64';
Vue.prototype.$Base64 = Base64;

/* IE下提示Promise未定义的解决方法 */
if (!window.Promise) {
    window.Promise = Promise;
}

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')